import React from 'react';
import { Player } from '@remotion/player';
import { PrixiaVideo } from './PrixiaVideo';
import { FPS, VIDEO_WIDTH, VIDEO_HEIGHT, TOTAL_DURATION } from './constants';

interface PrixiaPlayerProps {
  className?: string;
  style?: React.CSSProperties;
  autoPlay?: boolean;
  loop?: boolean;
  controls?: boolean;
}

export const PrixiaPlayer: React.FC<PrixiaPlayerProps> = ({
  className,
  style,
  autoPlay = false,
  loop = false,
  controls = true,
}) => {
  return (
    <Player
      component={PrixiaVideo}
      durationInFrames={TOTAL_DURATION}
      compositionWidth={VIDEO_WIDTH}
      compositionHeight={VIDEO_HEIGHT}
      fps={FPS}
      autoPlay={autoPlay}
      loop={loop}
      controls={controls}
      className={className}
      style={{
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto',
        aspectRatio: '16/9',
        borderRadius: 16,
        overflow: 'hidden',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)',
        ...style,
      }}
    />
  );
};
